// extracted by mini-css-extract-plugin
module.exports = {"container":"BranchList__container","anchor":"BranchList__anchor","results":"BranchList__results","highlightResults":"BranchList__highlightResults"};